import type { Category, Product } from '../types';
import type { ContentBook } from './index';

export type CollectionKey = keyof ContentBook['collections'];
const aliases: Record<CollectionKey, RegExp> = {
  black: /\bblack\b|ч[её]рн|შავი/iu,
  green: /\bgreen\b|зел[её]н|მწვანე/iu,
  oolong: /oolong|улун|ულუნ/iu,
  gaba: /\bgaba\b|габа|გაბა/iu,
  special: /special|специаль|особ|განსაკუთრებულ/iu,
  'white-yellow': /\bwhite\b|\byellow\b|белый|белые|ж[её]лт|თეთრი|ყვითელი/iu,
  accessories: /accessor|teaware|посуда|принадлежност|аксессуар|აქსესუარ|ჭურჭელ/iu,
  tours: /\btour|туры|туризм|ტურ/iu,
  hydrolats: /hydrolat|гидролат|ჰიდროლატ/iu,
  gifts: /\bgift|souvenir|подар|сувенир|საჩუქ|სუვენირ/iu,
};
export function parseCollection(value: string | null): CollectionKey | null {
  return value && Object.hasOwn(aliases, value) ? (value as CollectionKey) : null;
}
/** Match the catalog's real, localized category names; never invent category IDs or stock. */
export function collectionCategoryIds(categories: Category[], key: CollectionKey): number[] {
  return categories
    .filter((category) => {
      const names = [
        category.name,
        ...Object.values(category.translations ?? {}).map((entry) => entry.name ?? ''),
      ];
      return names.some((name) => aliases[key].test(name));
    })
    .map((category) => category.id);
}
export function filterCollection(
  products: Product[],
  categories: Category[],
  key: CollectionKey | null,
): Product[] {
  if (!key) return products;
  const ids = new Set(collectionCategoryIds(categories, key));
  return products.filter((product) => product.categoryId !== null && ids.has(product.categoryId));
}
